import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Validations } from '../../../shared/validations/validations';
import { ROOF_TYPE, BOOL_ARR, STORAGE_SIZE } from '../../../shared/constants';
import { EnumHelper } from '../../../shared/enum-helper';

import { SolarPanelService } from './solar-panel.service';

@Component({
  selector: 'app-solar-panel',
  templateUrl: './solar-panel.component.html',
  styleUrls: ['./solar-panel.component.scss', '../service-pages.component.scss']
})
export class SolarPanelComponent implements OnInit {
  faq!: any[];
  solarPanelForm!: FormGroup; disabled!: boolean; isSubmit!: boolean;
  storageSizeArr = STORAGE_SIZE; boolArr = BOOL_ARR; roofTypeArr!: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private solPanelSrv: SolarPanelService,
    private tSrv: Title
  ) { }

  ngOnInit(): void {
    this.initializeState();
  }

  initializeState() {
    this.tSrv.setTitle('Solar Panel | Don\'t Waste Money');
    this.disabled = false;
    this.faq = [];
    this.roofTypeArr = EnumHelper.enumToArray(ROOF_TYPE);
    this.initForm();
  }

  initForm() {
    this.solarPanelForm = this.fb.group({
      title: ['', Validators.required],
      firstName: ['', [Validators.required, Validations.nameValidation]],
      lastName: ['', [Validators.required, Validations.nameValidation]],
      email: ['', [Validators.required, Validations.emailValidation]],
      mobileNumber:['', [Validators.required, Validations.phoneValidation]],
      town: ['', [Validators.required]],
      streetName: ['', Validators.required],
      houseNumber: ['', Validators.required],
      postcode: ['', Validators.required],
      quantityOfPanels: ['', Validators.required],
      roofType: ['', Validators.required],
      scaffold: ['', Validators.required],
      storageSize: ['', Validators.required]
    });
  }

  counter(i: number) {
    return new Array(i);
  }

  onSubmit(formRef: FormGroupDirective) {
    this.isSubmit = true;
    if (this.solarPanelForm.valid) {
      this.disabled = true;
      let quData: any = {
        ...this.solarPanelForm.value
      }
      this.solPanelSrv.addSolarPanelQuote(quData)
        .subscribe((data: any) => {
          formRef.resetForm();
          this.disabled = this.isSubmit = false;
          this.toastr.success("Your request for quote has been submitted successfully, and you will receive a quotation at your email address in a few minutes.", undefined, {timeOut: 6000});
        }, (err: any) => {
          this.disabled = false;
        });
    }
  }

}
